module.exports = __webpack_public_path__ + "static/honeybee-logo-fr-956b71c474b3220bd74d6829cacbc706.png";